module.exports = __webpack_public_path__ + "static/media/html.3634f905.svg";